import React, { useCallback } from 'react';
import { SettingsItemNavigate, Spacer } from 'design-system';
import { IconBoldImage } from 'design-system/icons';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import TransactionLogo from '../TransactionLogo';
const strings = {
    add: 'Add custom logo',
    edit: 'Edit custom logo',
};
const TransactionEditLogoItem = ({ transaction }) => {
    const navigation = useMainStackNavigation();
    const onPress = useCallback(() => {
        navigation.navigate('SuggestMerchantOptions', {
            transactionId: transaction.id,
        });
    }, [transaction.id]);
    if (transaction.suggestedData) {
        return (<SettingsItemNavigate renderIcon={() => (<>
            <TransactionLogo transaction={transaction} R44/>
            <Spacer.W16 />
          </>)} title={strings.edit} onPress={onPress}/>);
    }
    return (<SettingsItemNavigate icon={<IconBoldImage gradientKey={'turquoise'}/>} title={strings.add} onPress={onPress}/>);
};
export default React.memo(TransactionEditLogoItem);
